module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vcirc5-e69db376800088e0a383091759d8cee9.jpg";